import React from 'react';

/**
 * Wow!CX Logo Component
 * Displays the official Wow!CX logo - new branding with blue arrow design
 * 
 * @param {string} size - 'sm' | 'md' | 'lg' | 'xl' - controls logo height
 * @param {boolean} showText - whether to show "Wow!CX" text alongside logo (not needed with new logo)
 * @param {string} className - additional CSS classes
 */
const WowCXLogo = ({ size = 'md', showText = false, className = '' }) => {
  const sizeClasses = {
    sm: 'h-8',    // 32px - for compact headers
    md: 'h-10',   // 40px - standard size
    lg: 'h-12',   // 48px - prominent placement
    xl: 'h-14'    // 56px - hero/landing sections
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img 
        src="/wowcx-logo.png?v=2"
        alt="Wow!CX"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default WowCXLogo;
